export type ChangeModalEscapeAction =
    | 'cancelMeta'
    | 'closeComposer'
    | 'closeModal'
    | 'none';

type ChangeModalEscapeState = {
    editingMeta: unknown;
    communicationComposerOpen: boolean;
    mergeModalIsVisible: boolean;
    relatedModalIsVisible: boolean;
    replyTemplatesManageOpen: boolean;
    pendingNonDevTypeFields: unknown;
};

/** Priority for Escape in the change detail modal. */
export function resolveChangeModalEscapeAction(
    state: ChangeModalEscapeState,
): ChangeModalEscapeAction {
    if (state.editingMeta)
        return 'cancelMeta';
    if (state.communicationComposerOpen)
        return 'closeComposer';
    if (
        state.mergeModalIsVisible
        || state.relatedModalIsVisible
        || state.replyTemplatesManageOpen
        || state.pendingNonDevTypeFields
    )
        return 'none';
    return 'closeModal';
}
